/**
 * 🧱 Refactor BT Phase 3 — T1 : sous-dialogues d'Éditer (AjusterCalendrier, LeaveConflict, ListeChargement,
 * ZonePhotoFullscreen, AlertDialog retrait membre) — JSX déplacé TEL QUEL (ex-L1079-1235, dédenté de 6) ;
 * variables via `useBTForm()`. DOM, data-testid, textes inchangés.
 */
import { API_URL } from '../../utils';
import { AjusterCalendrierDialog } from '../../AjusterCalendrierDialog';
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from '../../../../ui/alert-dialog';
import { Dialog } from '../../../../ui/dialog';
import { LeaveConflictDialog, ZonePhotoFullscreenDialog } from '../../BTSubDialogs';
import { ListeChargementDialog } from '../../../../echafauds/ListeChargementDialog';
import axios from 'axios';
import { toast } from 'sonner';
import { useBTForm } from '../../BTFormContext';

export function SousDialoguesEditer() {
  const {
    ajustementData,
    bon,
    dialogSuppression,
    doSave,
    dossier,
    fermerDialogSuppression,
    form,
    leaveConflicts,
    onClose,
    open,
    setForm,
    setShowAjustementDialog,
    setShowConfirmConge,
    setShowListeChargement,
    setZonePhotoFullscreen,
    showAjustementDialog,
    showConfirmConge,
    showListeChargement,
    zonePhotoFullscreen,
  } = useBTForm();
  return (
    <>
      {/* ✅ Modal d'ajustement automatique du calendrier */}
      <AjusterCalendrierDialog
        open={showAjustementDialog}
        onClose={() => setShowAjustementDialog(false)}
        ajustementData={ajustementData}
        datesActuelles={form.dates_chantier}
        btLies={dossier?.bons_travail?.filter(b => b.id !== bon.id) || []}
        onAjuster={async ({ nouvellesDates, ajusterBtsLies }) => {
          // Mettre à jour les dates du BT actuel dans le formulaire
          setForm(f => ({ ...f, dates_chantier: nouvellesDates }));
          
          // Si ajusterBtsLies, appeler API backend pour ajuster les autres BTs
          if (ajusterBtsLies && dossier?.id) {
            try {
              await axios.post(`${API_URL}/api/crm/dossiers/${dossier.id}/ajuster-bts-lies`, {
                bt_principal_id: bon.id,
                nouvellesDates,
                ecart_jours: ajustementData.ecart
              });
              toast.success(`Calendrier ajusté! ${ajusterBtsLies ? 'BTs liés aussi ajustés.' : ''}`);
            } catch (error) {
              console.error('Erreur ajustement BTs liés:', error);
              toast.warning('Calendrier mis à jour mais erreur sur les BTs liés');
            }
          } else {
            toast.success('Calendrier ajusté!');
          }
          
          setShowAjustementDialog(false);
        }}
      />

      {/* Dialog de confirmation — conflit de congé détecté à l'enregistrement */}
      {/* 🆕 [Phase 56 BT — P2.2] Extrait dans `BTSubDialogs.jsx` (Bug 4 protégé) */}
      <LeaveConflictDialog
        open={showConfirmConge}
        onClose={() => setShowConfirmConge(false)}
        onForceConfirm={async () => { setShowConfirmConge(false); await doSave(); }}
        leaveConflicts={leaveConflicts}
      />

      {/* 🆕 Modal Liste de chargement */}
      <ListeChargementDialog
        btId={bon?.id}
        open={showListeChargement}
        onClose={() => setShowListeChargement(false)}
      />

      {/* 🆕 2026-05-08 — Lightbox plein écran pour les photos de zone (depuis le formulaire de modification).
          Permet de voir la photo en entier sans cropping pendant qu'on édite les détails de la zone. */}
      {/* 🆕 [Phase 56 BT — P2.2] Extrait dans `BTSubDialogs.jsx` */}
      <ZonePhotoFullscreenDialog
        zone={zonePhotoFullscreen}
        onClose={() => setZonePhotoFullscreen(null)}
        apiUrl={API_URL}
      />

      {/* 🛡️ [Phase 61 — 2026-06-17] Dialog d'avertissement avant retrait d'un membre
          qui a encore ≥ 1 jour coché dans la matrice Présence par jour.
          🆕 [Bug prod 2026-07-16] 2 modes : « aPunche » (informatif, protection Phase 61)
          vs « jours cochés seuls » (confirmation destructive classique). */}
      <AlertDialog
        open={dialogSuppression.open}
        onOpenChange={(open) => { if (!open) fermerDialogSuppression(); }}
      >
        <AlertDialogContent
          data-testid="dialog-confirm-suppression-membre"
          data-a-punche={dialogSuppression.aPunche ? 'true' : 'false'}
        >
          {dialogSuppression.aPunche ? (
            /* ─── MODE 1 : Employé avec heures gravées (Phase 61) ─────────── */
            <>
              <AlertDialogHeader>
                <AlertDialogTitle data-testid="dialog-suppression-title-punche">
                  🔒 Employé avec heures gravées
                </AlertDialogTitle>
                <AlertDialogDescription asChild>
                  <div className="space-y-2">
                    <p>
                      <strong>{dialogSuppression.nom}</strong> a déjà travaillé sur ce
                      bon de travail (<strong>{dialogSuppression.joursPunches.length} jour(s)</strong>{' '}
                      avec punchs enregistrés).
                    </p>
                    <p className="text-slate-700">
                      Il ne peut <strong>pas être retiré complètement</strong>. Ses heures
                      déjà travaillées resteront préservées sur ce BT (règle Phase 61).
                    </p>
                    <details className="text-xs bg-emerald-50 border border-emerald-200 rounded p-2">
                      <summary className="cursor-pointer font-medium text-emerald-800">
                        Voir les jours avec punchs enregistrés
                      </summary>
                      <ul
                        className="mt-1 list-disc pl-5 max-h-32 overflow-y-auto"
                        data-testid="dialog-jours-punches"
                      >
                        {dialogSuppression.joursPunches.map(d => (
                          <li key={d} className="text-emerald-700">{d}</li>
                        ))}
                      </ul>
                    </details>
                    <p className="text-amber-700 text-sm">
                      Voulez-vous seulement le <strong>désactiver de « Présence par jour »</strong>{' '}
                      pour les prochaines dates non travaillées ?
                    </p>
                  </div>
                </AlertDialogDescription>
              </AlertDialogHeader>
              <AlertDialogFooter>
                <AlertDialogCancel data-testid="dialog-suppression-cancel">
                  Annuler
                </AlertDialogCancel>
                <AlertDialogAction
                  onClick={() => { if (dialogSuppression.onConfirm) dialogSuppression.onConfirm(); }}
                  className="bg-amber-600 hover:bg-amber-700"
                  data-testid="dialog-suppression-confirm-punche"
                >
                  Retirer de « Présence par jour »
                </AlertDialogAction>
              </AlertDialogFooter>
            </>
          ) : (
            /* ─── MODE 2 : Jours cochés sans punch (comportement Phase 61 classique) ─ */
            <>
              <AlertDialogHeader>
                <AlertDialogTitle>⚠️ Confirmer le retrait</AlertDialogTitle>
                <AlertDialogDescription asChild>
                  <div className="space-y-2">
                    <p>
                      <strong>{dialogSuppression.nom}</strong> a encore{' '}
                      <strong>{dialogSuppression.joursCoches.length} jour(s)</strong> coché(s)
                      dans <em>Présence par jour</em> :
                    </p>
                    <ul className="text-xs bg-slate-50 rounded p-2 max-h-32 overflow-y-auto list-disc pl-5" data-testid="dialog-jours-coches">
                      {dialogSuppression.joursCoches.map(d => (
                        <li key={d}>{d}</li>
                      ))}
                    </ul>
                    <p className="text-amber-700">
                      Le retirer va aussi <strong>vider tous ses jours</strong> sur ce BT.
                    </p>
                  </div>
                </AlertDialogDescription>
              </AlertDialogHeader>
              <AlertDialogFooter>
                <AlertDialogCancel data-testid="dialog-suppression-cancel">Annuler</AlertDialogCancel>
                <AlertDialogAction
                  onClick={() => { if (dialogSuppression.onConfirm) dialogSuppression.onConfirm(); }}
                  className="bg-red-600 hover:bg-red-700"
                  data-testid="dialog-suppression-confirm"
                >
                  Supprimer quand même
                </AlertDialogAction>
              </AlertDialogFooter>
            </>
          )}
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
}
